(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('estadoactual', {
            parent: 'entity',
            url: '/estadoactual',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.estadoactual.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/estadoactual/estadoactuals.html',
                    controller: 'EstadoactualController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('estadoactual');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('estadoactual-detail', {
            parent: 'estadoactual',
            url: '/estadoactual/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.estadoactual.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/estadoactual/estadoactual-detail.html',
                    controller: 'EstadoactualDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('estadoactual');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Estadoactual', function($stateParams, Estadoactual) {
                    return Estadoactual.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'estadoactual',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('estadoactual-detail.edit', {
            parent: 'estadoactual-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/estadoactual/estadoactual-dialog.html',
                    controller: 'EstadoactualDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Estadoactual', function(Estadoactual) {
                            return Estadoactual.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('estadoactual.new', {
            parent: 'estadoactual',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/estadoactual/estadoactual-dialog.html',
                    controller: 'EstadoactualDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fechacontrol: null,
                                aeropuerto: null,
                                comercio: null,
                                nroterminal: null,
                                status: null,
                                razon: null,
								metodo: null,
								impresora: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('estadoactual', null, { reload: 'estadoactual' });
                }, function() {
                    $state.go('estadoactual');
                });
            }]
        })
        .state('estadoactual.edit', {
            parent: 'estadoactual',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/estadoactual/estadoactual-dialog.html',
                    controller: 'EstadoactualDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Estadoactual', function(Estadoactual) {
                            return Estadoactual.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('estadoactual', null, { reload: 'estadoactual' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('estadoactual.delete', {
            parent: 'estadoactual',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/estadoactual/estadoactual-delete-dialog.html',
                    controller: 'EstadoactualDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Estadoactual', function(Estadoactual) {
                            return Estadoactual.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('estadoactual', null, { reload: 'estadoactual' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
